module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.58.18.af7ff034.jpg";